import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  TrainingAdminDto,
  TrainingAdminQueryDto,
  CancelTrainingDto,
} from '../types/admin-api';

export const trainingService = {
  getAll: async (query: TrainingAdminQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<TrainingAdminDto>>(
      '/trainings',
      { params: query }
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<TrainingAdminDto>(`/trainings/${id}`);
    return response.data;
  },

  cancel: async (id: string, data: CancelTrainingDto) => {
    const response = await apiClient.delete(`/trainings/${id}`, { data });
    return response.data;
  },
};
